<template lang="pug">
.w-100
    .tabela(v-if='false')

    EmptyResultLaudo(
         v-else
        :semLaudoSelecionado='true'
        :p1="$t('mensagens.laudos.nenhumLaudoSelecionado')",
        :p2="$t('mensagens.laudos.selecioneTipoDeLaudoParaVisualisar')"
    )
</template>

<script>
import EmptyResultLaudo from '@/components/laudos/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagemDashboard',
    components: {
        EmptyResultLaudo
    },
    data() {
        return {};
    }
};
</script>
